/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
	// newImageSrc is the path of the new image in the same size as originalImage is sized.
	// newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
	// mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
	jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
	jQuery(mainImageDomEl).attr('src', newImageSrc);  
};

var owlArgs = {
	pagination: false,
	singleItem: true,
	slideSpeed: 300,
	paginationSpeed: 300,
	autoPlay: false,
	lazyLoad: true,
	touchDrag: true,
	mouseDrag: true,
	navigation: true,
	navigationText: ['','']
}

var partnerOwlArgs = {
	pagination: false,
	slideSpeed: 300,
	paginationSpeed: 300,
	autoPlay: true,
	touchDrag: true,
	mouseDrag: true,
	items: 4,
	itemsScaleUp: true
}

function resetHeight(item) {

	item.addClass('reset-height');
}

function sameHeight(items) {
	var maxHeight = 0;
	console.log("items count: " + items.length);
	resetHeight(items);
	items.each(function() {
		// resetHeight($(this));
		// console.log("reset height: " + $(this).css('height'));
		// console.log("reset-height: " + $(this).hasClass('reset-height'));
		if($(this).height() > maxHeight) maxHeight = $(this).height();
		console.log(maxHeight);

	});
	items.height(maxHeight);
	items.removeClass("reset-height");
}

function fixHeight(tile) {
	var maxHeight = 0;
	tile.find('.location-image').height(tile.find('.location-details').innerHeight());
}

function runHash(hash) {
	console.log(hash);
	var offset = 0;
	var section, sectionLink, newTop;
	var slug = hash.replace('#','');
	section = $('[data-article-id="'+slug+'"]');
	console.log(hash);
	newTop = section.offset().top;
	scrollToSection(newTop);
}

function loadHashLocation() {
	initialState = {};
	if(location.hash !== "") {
		var hash = location.hash;
		runHash(hash);
	}
	else {
		// $(".accordion-item:first .section-header-bar").trigger('click');
	}
}

function scrollToSection(newTop) {
	console.log(newTop);
	if($("html.mac.safari").length > 0) {
		setTimeout(function() {
			$(window).scrollTop(newTop);
		}, 100);
	}
	else {
		TweenMax.to($(window), 0.6, {
			scrollTo: newTop
		});
	}

}

function hideLoader() {
	TweenLite.to(".main-loader", 0.4, {opacity: 0, delay: 0.2, onComplete: function() {
		$(".main-loader").addClass('hidden');
		$("html").css('background-color', 'rgb(142,101,64)');
	}});
	TweenLite.to($(".page-wrapper"), 0.4, {opacity: 1, onComplete: function() {
		loadHashLocation();
	}});

	
}

function isScrolledIntoView(elem) {
	var $elem = $(elem);
	var $window = $(window);

	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();

	var elemTop = $elem.offset().top;
	var elemBottom = elemTop + $elem.height();

	return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}


function ScrollExecute() {
	console.log("SCROLLING");
	scrollNode = $('#more');
	// if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
	if(isScrolledIntoView(scrollNode)) {
		 // console.log(scrollNode);
		 scrollURL = $('#more a').attr("href");
		 if(scrollNode.length > 0 && scrollNode.css('display') != 'none') {
			$.ajax({
				type: 'GET',
				url: scrollURL,
				beforeSend: function() {
					scrollNode.find('.spinner').css('display', 'inline-block');
				},
				success: function(data) {
					var page = $('#more a').attr('href').split('page=');
					var newNum = parseInt(page[1]) + 1;
					page[1] = 'page=' + newNum;
					page = page.join('');
					var filteredData = $(data).find(".grid-product");
					var nextButton = $(data).find('#more');
					console.log('has next: ' + nextButton.length);
					if(filteredData.length > 0) {
						$(".products-grid").append(filteredData);
						scrollNode.find('a').attr('href', page);
					}
					if(nextButton.length === 0) scrollNode.hide();
					scrollNode.find('.spinner').hide();
					resizeFunctions();
				},
				dataType: "html"
			});
		 }
		}
	}

	function checkConfEmail(e) {
		var form = $(this);
		var email = $(this).find('[name="contact[email]"]').val();
		var emailConf = $(this).find('[name="contact[confirm-email]"]').val();
		if(email !== emailConf || emailConf === '') {
			alert('Please check your email!');
			e.preventDefault();
		//return false;
	}
}

function resizeEnd() {
	if($(".locations").length > 0) {
		$('.locations .location-tile').each(function() {
			fixHeight($(this));
		});
	}

	if($(".announcement-tile").length > 1) {
		if(innerWidth > 767) $(".home-announcements").find('.grid-group').addClass('flexbox')
		else $(".home-announcements").find('.grid-group').removeClass('flexbox')
	}

	if($(".grid-product").length > 1) {
		sameHeight($(".grid-product"));
	}
}

function resizeFunctions() {
	if(this.resizeTO) clearTimeout(this.resizeTO);
	
	// ** add code to blacken visible area on resize
	
	//when resize complete
	this.resizeTO = setTimeout(function() {
		resizeEnd();
	}, 300);
}



jQuery(function($) {

	/* Placeholder JS */
	/*==========================*/
	var test = document.createElement('input');
	if (!('placeholder' in test)) {
		$('[placeholder]').each(function(){
			if ($(this).val() === '') {
				var hint = $(this).attr('placeholder');
				$(this).val(hint).addClass('hint');
			}
		});
		$('[placeholder]').focus(function() {
			if ($(this).val() === $(this).attr('placeholder')) {
				$(this).val('').removeClass('hint');
			}
		}).blur(function() {
			if ($(this).val() === '') {
				$(this).val($(this).attr('placeholder')).addClass('hint');
			}
		});    
	}

	/* Form validation JS */
	/*==========================*/

	$('input.error, textarea.error').focus(function() {
		$(this).removeClass('error');
	});

	$('form :submit').click(function() {
		$(this).parents('form').find('input.hint, textarea.hint').each(function() {
			$(this).val('').removeClass('hint');
		});
		return true;
	});
	
	/* Remove SVG images to avoid broken images in all browsers that don't support SVG. */
	/*==========================*/
	
	var supportsSVG = function() {
		return document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#Image', '1.1');
	}  
	if (!supportsSVG()) {
		$('img[src*=".svg"]').remove();
	}
	
	/* Prepare to have floated images fill the width of the design on blog pages on small devices. */
	/*==========================*/ 

	var images = $('.article img').load(function() {
		var src = $(this).attr('src').replace(/_grande\.|_large\.|_medium\.|_small\./, '.');
		var width = $(this).width();
		$(this).attr('src', src).attr('width', width).removeAttr('height');
	});
	
	/* Update main product image when a thumbnail is clicked. */
	/*==========================*/
	// $('.product-photo-thumb a').on('click', function(e) { 
	//   e.preventDefault();
	//   switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
	// } );

	// Enable home page slider
	owl = $('.home-carousel').owlCarousel(owlArgs);
	$('.partner-carousel').owlCarousel(partnerOwlArgs);

	resizeFunctions();
	$(window).resize(resizeFunctions);

	if($('#locations').length > 0) {
		$(".location-tile").each(function() {
			args = {
				canvasID: $(this).find('.map-canvas').attr('id'),
				addrList: $(this).find('h1, h2')
			}
			var maps = locationMap(args);
			maps.enable();
		});
	}

	hideLoader();

	$(".toggle-menu").click(function() {
		$('.site-nav').toggleClass('expand');
		TweenLite.to(window, 0.2, {scrollTo: $(".site-nav").offset().top});
	});

	if($('.template-collection').length > 0) {
		console.log("we got collections y'all!!");
		$(window).scroll(function(){
			$.doTimeout( 'scroll', 200, ScrollExecute);
		});
	}

	if($("#contactFormWrapper").length > 0) {
		$("#contactFormWrapper").closest('form').submit(checkConfEmail);
	}

	if($('.template-product').length > 0) {
		$('.sub-nav .active').closest('.has-dropdown').addClass('active');
	}

	if($('body').hasClass('template-cart')) $('li.cart-link').addClass('active');

	$('.in-page-link').click(function(e) {
		e.preventDefault();
		runHash('#' + $(this).attr('data-hash-link'));
	});

});
